import * as React from "react";
import { isPrint } from "../../utils";
import { IExplorerProperties } from "../../models";
import { BackToTop } from "../../assets/BackToTop/BackToTop";

const styles = require('./FundExplorerTabs.pcss');
const backToTopstyles = require('./overrides/BackToTopoverride.pcss');

export class FundExplorerFooter extends React.Component<IExplorerProperties, {}>{
	constructor(props) {
		super(props);

		this.handleLoadMore = this.handleLoadMore.bind(this);
	}

	getRetreivedShareClassCount(funds) {
		return funds.values.reduce((acc, f) => {
			acc += f.shareClasses.length;
			return acc;
		}, 0);
	}

	handleLoadMore(showAll: boolean = false) {
		let { infiniteScroll, execInfiniteScroll } = this.props;

		if (!infiniteScroll.loading) {
			return execInfiniteScroll(this.props.appParams, showAll);
		}
	}

	getDistFromBottom() {
		let scrollPosition = window.pageYOffset;
		let windowSize = window.innerHeight;
		let bodyHeight = document.body.offsetHeight;

		return Math.max(bodyHeight - (scrollPosition + windowSize), 0);
	}

	handleScroll() {
		let distToBottom = this.getDistFromBottom();
		if (distToBottom < 200) {
			this.handleLoadMore();
		}
	}

	render() {
		let { funds, isLoading, infiniteScroll, appParams } = this.props;
		let retreivedShareClassCount = this.getRetreivedShareClassCount(funds);

		return (
			<div>
				{
					funds.shareClassTotal > retreivedShareClassCount
					&& !isLoading
					&& <button onClick={() => this.handleLoadMore()} className={styles.loadMore} type="button">{infiniteScroll.loading ? "LOADING..." : "LOAD MORE"}</button>
				}

				{
					funds.shareClassTotal > retreivedShareClassCount
					&& !isLoading
					&& <button onClick={() => this.handleLoadMore(true)} className={`${styles.loadMore} ${styles.loadAll}`} type="button">{infiniteScroll.loading ? "LOADING..." : "LOAD ALL FUNDS"}</button>
				}

				{
					!isLoading
					&& !isPrint(appParams)
					&& <BackToTop styles={backToTopstyles} />
				}

			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/client/components/FundExplorerTabs/FundExplorerFooter.tsx